import React from "react";
import { Td, Tr } from "@chakra-ui/react";

const bold = { fontWeight: "bold" };

const TbodyGarbagesUnit = ({ data, iope }) => {
  return (
    <Tr>
      {console.log(data)}
      <Td className="text-center">{}</Td>
      <Td className="text-center">{}</Td>
      <Td className="text-center">{}</Td>
      <Td className="text-center" isNumeric style={bold}>
        {data?.total_unit}
      </Td>
      <Td className="text-center" style={bold}>
        {data?.unit}
      </Td>
    </Tr>
  );
};

export default TbodyGarbagesUnit;
